import React from 'react';
import { MdSearchOff } from 'react-icons/md';

const NoResults = ({ message = "No crops found matching your search." }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-4 text-center">
      <div className="w-16 h-16 rounded-full bg-slate-100 flex items-center justify-center mb-5">
        <MdSearchOff className="w-8 h-8 text-slate-400" />
      </div>
      <p className="text-lg font-bold text-slate-800 mb-1">{message}</p>
      <p className="text-sm text-slate-500">Try adjusting your search or selecting a different category</p>
    </div>
  );
};

export default NoResults;
